import RecruiterSignUpForm from 'components/modules/auth/RecruiterSignUpForm/RecruiterSignUpForm';
import AuthCardLayout from 'layouts/AuthCardLayout';

function RecruiterSignUp() {
  return (
    <AuthCardLayout className="card-sign-up">
      <RecruiterSignUpForm />
    </AuthCardLayout>
  );
}

export default RecruiterSignUp;
